import { SectionSubNav } from "../../components/SectionSubNav";
import type { TabItem } from "../../components/Tabs";

/** The four canonical Fleet pages (docs/product/ui-information-architecture.md
 * §3, IA slice 2/6) and the route each one owns. Order matches the founder-approved
 * reading order: the unified machine view first, then the policy grouping around
 * it, then the two read-only/advanced views. */
const FLEET_TAB_ITEMS: TabItem[] = [
  { id: "hosts", label: "Machines" },
  { id: "environments", label: "Environments" },
  { id: "routes", label: "Routes" },
  { id: "instances", label: "Instances" },
];

const FLEET_TAB_PATHS: Record<string, string> = {
  hosts: "/hosts",
  environments: "/environments",
  routes: "/routes",
  instances: "/instances",
};

export type FleetTabId = keyof typeof FLEET_TAB_PATHS;

/**
 * Fleet section sub-navigation, mounted on the section's four top-level LIST
 * pages (HostsListPage, EnvironmentsListPage, RoutesListPage, InstancesListPage
 * — App.tsx). Before this existed, three of those four pages (`/environments`,
 * `/routes`, `/instances`) had no link into them from anywhere in the app —
 * `git grep 'to="/environments"'` etc. found only a detail page's own back-link
 * — reachable only by a typed URL, which is how the founder got stuck looking
 * for Environments on canary. `NavSidebar`'s "Fleet" destination only links to
 * `/hosts` (its landing page, IA slice 2); this closes the rest of the section.
 *
 * A thin config wrapper around the shared `SectionSubNav` (A-12: Operate's
 * identical need — Services/Health/Alerts — is the second copy that earned
 * the extraction; this component now only owns Fleet's tab list/paths).
 */
export function FleetSubNav({ activeTab }: { activeTab: FleetTabId }) {
  return <SectionSubNav items={FLEET_TAB_ITEMS} paths={FLEET_TAB_PATHS} activeTab={activeTab} ariaLabel="Fleet views" />;
}
